











import { Component, Prop, Vue } from 'vue-property-decorator';
import TextInput from './_text.input.vue';
@Component({
  components: {
    'text-input': TextInput
  },
})
export default class InuptPhone extends Vue {

  @Prop()
  placeholder!: string;

  public label = 'Teléfono';
  public error = '';
  public icon = 'phone'

  onChange($text) {
    console.error($text)
      if($text.length === 0){
          this.error = 'Teléfono invalida';
      } else {
        this.$emit('nChange', $text)
          this.error = '';
      }
  }

}
